import React from 'react';
import PropTypes from 'prop-types';
import KpiTable from '../../../commons/KpiTable';

const StudentStudyQualityTable = (props) => (
  <KpiTable
    title="Study Quality"
    description="The number represents the study quality average of students who have studied in the reference month."
    loading={props.loading}
    values={props.values}
    currentHigherIsBetter={true}
    feedbackColorRender={props.feedbackColorRender}
    onSelect={props.onSelect}
    formatter={props.formatter}
    additionalColumns={[
      {
        label: 'Standard Deviation',
        path: 'currentStandardDeviation',
      },
      {
        label: 'Total of Registers',
        path: 'currentAmount',
      },
    ]}
  />
);

StudentStudyQualityTable.propTypes = {
  onSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func.isRequired,
};

export default StudentStudyQualityTable;
